/**
 * Normalize path so it matches location.pathname (always has leading /).
 * Backend may send "admin/org" or "/admin/org" — we support both.
 */
export function normalizePath(p: string): string {
  return p.startsWith('/') ? p : `/${p}`;
}
